/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { providers, discovery } from "dc-core";
import * as stores from "stores";
import { getFileExtension } from "selectors/documentSelectors";

/**
 * Loads dropin by name.
 * @return Promise which resolves with dropin class.
 */
export const loadDropin = name => providers.discovery().then(discovery => discovery.loadDropinClass(name));
const callDropinMethod = (dropinId, methodName, opts) => discovery.callBootstrapMethod(dropinId, methodName, opts);

export const copyPreviewSelection = async selectionName => {
  const selection = await providers.selection();
  const newSelection = selection.registerSelection(selectionName);
  newSelection.clearSelection(); // just in case
  const previewSelection = selection.registerSelection("preview");
  previewSelection.selectedItems.forEach(item => {
    newSelection.selectItem(item.asset_id, item);
  });
};
export const fetchFileSelectionParams = (verbId, opts = {}, context) =>
  new Promise((resolve, reject) => {
    callDropinMethod(verbId, "getFileSelectionParams", {
      ...opts,
      context
    }).then(
      resp => {
        resolve(resp);
      },
      err => {
        reject(err);
      }
    );
  });
export const doesToolSupportFileExtension = (verbId, context) => {
  const fileExtension = getFileExtension(stores).toLowerCase();
  return fetchFileSelectionParams(verbId, {}, context).then(
    fileSelectionParams => fileSelectionParams && fileSelectionParams.acceptExtensions.includes(fileExtension)
  );
};

export const fetchVerbLabel = (verbId, opts = {}, context) =>
  new Promise((resolve, reject) => {
    callDropinMethod(verbId, "getLabel", {
      ...opts,
      context
    }).then(
      resp => {
        resolve(resp);
      },
      err => {
        reject(err);
      }
    );
  });

export const fetchVerbTooltip = (verbId, opts = {}, context) =>
  new Promise((resolve, reject) => {
    callDropinMethod(verbId, "getTooltip", {
      ...opts,
      context
    }).then(
      resp => {
        resolve(resp);
      },
      err => {
        reject(err);
      }
    );
  });

export const callInitializeAction = (dropinId, opts = {}) =>
  callDropinMethod(dropinId, "initializeAction", {
    ...opts
  });

export const callExecuteAction = (dropinId, opts = {}) =>
  callDropinMethod(dropinId, "executeAction", {
    ...opts
  });
